/* eslint-disable no-unused-vars */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';

const TermsOfUseComponent = () => {
  return (
    <div className="v1811_831">
      <div className="v1811_947" />
      <div className="v1811_989" />
      <div className="v1811_990" />
      <span className="v1811_991">Terms of Use</span>
      <div className="row mt-2" />
      <div className="row mt-2" />
      <div className="row mt-5">
        Conduent Inc. ("Conduent") makes this Site available in accordance with
        these Web Site Terms of Use ("Terms"). These Terms govern your access to
        and use of this Site. By accessing this Site you accept and agree to
        comply with all of the Terms. If you do not agree with these Terms,
        please do not use this Site and exit immediately. © Copyright 1994-2010
        Conduent Inc. All rights Reserved. Conduent® and the Conduent design are
        trademarks of Conduent Marketing LP in the US and/or other Countries.
      </div>
      <div className="row mt-3">
        Please click one of the following links to view the usage information.{' '}
        <br />
        Information Submitted to Conduent <br /> Third Party Web Sites <br />{' '}
        Use of Site Content <br /> Disclaimer of Warranties <br /> Limitation of
        Liability <br /> Trademarks Termination Revisions <br /> Applicable Law
      </div>
      <div className="row mt-3">
        Information Submitted to Conduent. Other than personally identifiable
        health information as provided in the Conduent Online Privacy Statement,
        any other information sent to Conduent through this Site will be treated
        as non-confidential. You grant to Conduent an unrestricted,
        royalty-free, irrevocable license to use, reproduce, display, perform,
        modify, transmit and distribute the non-confidential information. You
        agree that Conduent is entitled to use for any purpose whatsoever any
        ideas, concepts, know-how or techniques that you send, without any
        obligation of compensation to you or any other person. Your personally
        identifiable information that you submit will be treated in accordance
        with the Conduent Online Privacy Statement that accompanies this Site or
        as more specifically described in another Conduent web site you may
        access.
      </div>
      <div className="row mt-3">
        You are prohibited from posting on this Site or transmitting to or from
        this site any material that is false or inaccurate, solicitous,
        advertising, unlawful, threatening, libelous, defamatory, inflammatory,
        obscene, profane, pornographic, invasive of a person's privacy or could
        give rise to any civil or criminal liability under the law. You are
        prohibited from posting or transmitting to this Site any copyrighted
        material or material that is confidential to a third party.
      </div>
      <div className="row mt-3">
        Conduent has the right but not the obligation to monitor and review
        transmissions, bulletin boards, postings and chat rooms on this Site.
        Conduent assumes no liability with respect to such activities or the
        content of any such locations.
      </div>
      <div className="row mt-3">
        Third party Web Sites. References on this Site to any names, marks,
        products or services of any third parties or links to third party sites
        are provided solely as a convenience to you and do not constitute or
        imply an endorsement or sponsorship by Conduent or an affiliation with
        the third party. You agree that Conduent will not be responsible for any
        damage or loss incurred in connection with the third party web sites or
        any products or services available from the third party.
      </div>
      <div className="row mt-3">
        Use of Site Content. © Copyright 1994 - 2010 Affiliated Computer
        Services, Inc. All Rights Reserved. Conduent ® and the Conduent design
        are trademarks of Conduent Marketing LP in the US and/or other
        countries.
      </div>
      <div className="row mt-3">
        All information, text, software, audio, video, photographs, images and
        other data contained on this Site ("Site Content") are the property of
        Conduent or licensed to Conduent. Site Content is protected by copyright
        laws and other proprietary rights laws. You are authorized to access
        this Site solely for informational, non-commercial purposes to view and
        browse Site Content. Use of Site Content for any purpose except as
        provided in these Terms or as stated in the text on the Site is
        prohibited.
      </div>
      <div className="row mt-3">
        Disclaimer of Warranties. Conduent is not responsible for any errors or
        omissions contained on this Site. All Conduent and third party
        information is provided "AS IS". Conduent DISCLAIMS ALL WARRANTIES,
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT
        OF INTELLECTUAL PROPERTY, OR ARISING FROM A COURSE OF DEALING, USAGE, OR
        PRACTICE. Some jurisdictions do not allow the exclusion of implied
        warranties, so the above exclusion may not apply to you.
      </div>
      <div className="row mt-3">
        Limitation of liability. IN NO EVENT WILL CONDUENT BE LIABLE FOR ANY
        DAMAGES WHATSOEVER, INCLUDING BUT NOT LIMITED TO ANY DIRECT, SPECIAL,
        INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES FOR LOST
        PROFITS, LOST REVENUE OR LOSS OF USE, ARISING OUT OF OR RELATED TO THE
        USE OR INABILITY TO USE THIS SITE, ITS CONTENT OR LINKS, INCLUDING
        DAMAGES CAUSED BY OR RELATED TO INTERRUPTIONS, DEFECTS, DELAY IN
        OPERATION OR TRANSMISSION, OR COMPUTER VIRUS, EVEN IF Conduent HAS BEEN
        ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </div>
      <div className="row mt-3">
        Trademarks. The trademarks, service marks, logos and slogans appearing
        on this Site ("Marks") are the registered or common law marks of
        Conduent or designated third parties. No right or license is granted, by
        implication, estoppel or otherwise, to use the Marks or any other
        intellectual property rights of Conduent or any third party.
      </div>
      <div className="row mt-3">
        Termination. Conduent reserves the right in its sole discretion to
        terminate your access to or use of this Site for any reason, including a
        failure by you to comply with these Terms. Conduent may choose to take
        legal action against you for your failure to comply with these Terms.
      </div>
      <div className="row mt-3">
        Revisions. Conduent may revise or withdraw all or any portion of Site
        Content and discontinue any products or services at any time without
        notice. By accessing this Site you agree to be bound by any revisions
        made by Conduent and you agree that you will visit these Terms regularly
        to view the then-current Terms.
      </div>

      <span className="v1811_997">Web Site Terms of Use</span>
    </div>
  );
};
export default TermsOfUseComponent;
